import {Component, OnInit} from '@angular/core';
import {PublicService} from 'web-angular-client';
import {ActivatedRoute, Router} from '@angular/router';
import {ROUTES} from '../../app.routes';

@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.scss'],
    standalone: false
})
export class InvoiceComponent implements OnInit
{
    invoiceToken: string;
    errorMessage: string = '';

    constructor(protected publicService: PublicService, protected route: ActivatedRoute, protected router: Router)
    {
    }

    ngOnInit()
    {
        this.invoiceToken = this.route.snapshot.paramMap.get('invoiceToken');

        if (!this.invoiceToken?.trim())
        {
            this.router.navigate([ROUTES.PUBLIC.LOGIN.path]).then();
        }
        this.downloadInvoice();
    }

    public downloadInvoice()
    {
        this.publicService.getInvoiceByToken(this.invoiceToken)
            .subscribe({
                next: (response) =>
                {
                    const pdfUrl = URL.createObjectURL(response);
                    window.open(pdfUrl, '_blank');
                    this.errorMessage = '';
                }, error: (error) =>
                {
                    this.errorMessage = 'The invoice link is only valid while the payment is still in the pending state.';
                }
            });
    }
}
